import { render, staticRenderFns } from "./Cedentes.vue?vue&type=template&id=f4f08f90&scoped=true&"
import script from "./Cedentes.vue?vue&type=script&lang=js&"
export * from "./Cedentes.vue?vue&type=script&lang=js&"
import style0 from "./Cedentes.vue?vue&type=style&index=0&id=f4f08f90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f08f90",
  null
  
)

export default component.exports